const setUser = (action, state) => {
  const newState = { ...state };
  newState.me.loading = false;

  newState.me.user = { ...action.payload };
  return newState;
};

export default (state, action) => setUser(action, state);
